import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payment";
import TextsmsIcon from "@mui/icons-material/Textsms";
import { reset as userReset } from "../../redux/userSlice";
import { reset as insuranceReset } from "../../redux/insuranceSlice";
import { reset as stripeReset } from "../../redux/stripeSlice";
import Question from "../../components/Question";
import InfoCard from "../../components/InfoCard";
import { handleContactCareTeam } from "../../lib/utils";

export default function PaymentCancel(props) {
  const dispatch = useDispatch();

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  useEffect(() => {
    dispatch(userReset());
    dispatch(insuranceReset());
    dispatch(stripeReset());
  }, [dispatch]);

  return (
    <Question
      noBack={true}
      backgroundColor="#82B1FF33"
      componentHeight="100vh"
      title="Payment not completed"
      input={
        <>
          <InfoCard
            icon={PaymentIcon}
            title="Need to try again?"
            description="You can return to your message and use the payment link again, or contact the care team if you need help."
          />

          <Stack
            direction="column"
            spacing={2}
            mt={3}
            sx={{
              width: "100%",
              alignItems: "center",
            }}
          >
            <Button
              fullWidth
              variant="outlined"
              startIcon={<TextsmsIcon />}
              onClick={handleContactCareTeam}
              sx={{
                width: isDesktop ? "50%" : "100%",
                borderColor: "piction.highlight",
                backgroundColor: "piction.highlight",
                color: "white",
                borderRadius: "20px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                px: 2.5,
                "&:hover, &:active, &:focus": {
                  backgroundColor: "piction.highlight",
                  borderColor: "piction.highlight",
                  color: "white",
                  boxShadow: "none",
                },
              }}
            >
              Text Us
            </Button>
          </Stack>
        </>
      }
      {...props}
    />
  );
}